module.exports = __webpack_public_path__ + "static/img/book42.7dc9d54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book42.jpg
// module id = Owq0
// module chunks = 1